import styles from './styles.module.scss';

const Loader = () => <span className={styles.loader}></span>;

export default Loader;
